import React from 'react';

import {
  AccountCircle as AccountCircleIcon,
  Assignment as AssignmentIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PopoverProps
} from '@mui/material';
import _ from 'lodash';
import {
  authService,
  routeDirectory
} from 'modules';
import { useNavigate } from 'react-router-dom';



interface IProps {
  anchorEl: PopoverProps['anchorEl'];
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const navigate = useNavigate();



  return (
    <Menu
      anchorEl={props.anchorEl}
      open={!_.isNil(props.anchorEl)}
      onClose={props.onClose}
      style={{ marginTop: '8px' }}>
      <MenuItem onClick={() => navigate(routeDirectory.myProfile.path())}>
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>

        <ListItemText>
          View Your Profile
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={props.onClose}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>

        <ListItemText>
          Terms of Service
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => authService.logOut()}>
        <ListItemIcon>
          <LogoutIcon style={{ color: '#EB5757' }} />
        </ListItemIcon>

        <ListItemText style={{ color: '#EB5757' }} >
          Logout
        </ListItemText>
      </MenuItem>
    </Menu>
  );
};
